<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card title="GPX ricevuto" subtitle="Cosa vuoi farne?"
            class="pa-2" flat>
          <v-form ref="form" lazy-validation>
            Crea una nuova traccia da questo GPX:<br>
            scegli fra: 1,2,3...
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>

</script>
